/**
 * EcosystemOrgsForm: edit form for the `ecosystem-orgs` dynamic block.
 *
 * data: { limit? }
 *
 * The block renders a live carousel of randomly selected approved organizations;
 * the only configuration is an optional cap on how many to show. An empty
 * limit input stores no `limit` key, letting the block fall back to its default (9).
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

export default function EcosystemOrgsForm({ data, onChange }) {
    const d = data || {};

    const handleLimit = (raw) => {
        const trimmed = raw.trim();
        if (trimmed === '') {
            const rest = { ...d };
            delete rest.limit;
            onChange(rest);
            return;
        }
        const parsed = Number(trimmed);
        if (Number.isNaN(parsed)) {
            return;
        }
        onChange({ ...d, limit: parsed });
    };

    return (
        <Form.Group controlId="ecosystem-orgs-limit">
            <Form.Label>Maximum organizations to show</Form.Label>
            <Form.Control
                type="number"
                min={1}
                value={d.limit === undefined ? '' : d.limit}
                onChange={(e) => handleLimit(e.target.value)}
                placeholder="Leave blank for the default (9)"
            />
            <Form.Text muted>
                This block renders a random selection of approved organizations
                in this ecosystem. Leave blank to use the default count.
            </Form.Text>
        </Form.Group>
    );
}

EcosystemOrgsForm.propTypes = {
    data: PropTypes.object,
    onChange: PropTypes.func.isRequired,
};

EcosystemOrgsForm.defaultProps = {
    data: {},
};
